import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        avatar      : 1,
        email       : null,
        name        : null,
        id          : null,
        info_started: false,
        points      : 0,
        token       : null,
        logged      : false,
        mobile      : false,
        started     : false,
        player      : null,
        item        : 1,
        itens_count_day: 0,
        itens       :
        [
            "oleo",
            "pneu",
            "tonelagua",
            "canoquebrado",
            "balde",
            "mangueira",
            "potedog",
            "torneira",
            "lixo",
            "vasoplanta"
        ],
        itens_name:
        [
            "Óleo",
            "Pneu",
            "Tonel de água",
            "Cano quebrado",
            "Balde",
            "Mangueira",
            "Pote de água",
            "Torneira",
            "Lixo",
            "Vaso de planta"
        ],
        itens_ref:
        [
            'barriloleo',//
            'Pneu',//
            'barrilagua',//
            'canoquebrado__1_',//
            'Balde',//
            'Mangueira',//
            'PoteDog',
            'Torneira',//
            'Lixo',
            'Pote'//
        ],
        itens_fase_2:
        [
            [[28.772032726862612, 0.03769999900972287, 62.564239131670426], [-78.2070626196609, 26.748875414051508, 191.10122667364388]],
            [[-40.61003363087395, 0.03770000121726391, 53.6387998307723], [180.98466888991453, 0.21999999130220793, 48.00230185112609]],
            [[81.40507524272599, 0.03769999967889048, 77.99577913785615], [-6.033556184310713, 0.0377000000935479, 46.8495339197641]],
            [[265.26752413895446, 10.572983185421448, -19.807946806284424], [-128.6963793528386, 25.220040809980947, -101.37162671957718]],
            [[285.68203843131954, 14.854763485473185, -24.458926282101036], [-118.73884873919646, 32.8062233986948, -181.0117619163558]],
            [[198.5293288924768, 9.360000272141164, 82.64704106317714], [-89.72491444453888, 0.037700001259938665, -43.53881940389734 ]],
            [[251.6488402725411, 11.44000041446331, 95.0758667461948], [234.123877420175, 0.2199999934402439, 19.192088601043785]],
            [[228.9210886000348, 0.21999999765770561, 35.0605183987557], [233.21954397049723, 1.185000040147583, 26.918611589737413]],
            [[48.67272502478628, 52.848125116509316, -218.65892259321174], [250.3669541381465, 5.33999998567197, -11.345837240043217]],
            [[68.4820308029704, 0.03770000049018196, -105.79798194628567], [211.14680063761614, 0.17366607466261574, -54.075843505178206]],
        ],
        itens_pos:
        [
            //oleo
            [
                //ok
                [-77.74500120366154, 0.009999999883987032, -10.320804122052932],
                [-71.81824175979885, 0.010000000042080792, 63.3907659267163],
                [-38.34458716066794, 0.009999999981689545, 60.54733132820509],
                [28.024120983248554, 0.00999999985088973, -82.70002808491945],
                [233.00877688934844, 0.2199999928780081, 10.56035679090957],////
                [234.10303449410122, 0.17366606954670294, -45.26134421395114],////
                [220.5171565986176, 0.21999998887771732, 49.13684703547902],
                [210.97560673393312, 0.010000000115128582, 24.782384356485974],
                [162.80455532815708, 0.01520000031807478, 42.90131454209102],////
                [250.97470512243706, 0.009999999948531846, -3.7478952705603024],
                [31.33207452958972, 0.010000000403146858, 67.02176669407196],
                [103.34285402316057, 0.009999999885359934, 1.3496002266698164],
            ],
            //pneu
            [
                //ok
                [213.43589357265614, 0.2199999933414749, 56.7794799501487], 
                [199.92153101011172, 0.21999998869673432, -7.109206429828634], 
                [224.3967455121337, 0.22000000179617474, 19.060799388564273], 
                [-74.8787739623587, 0.009999999534661796, 2.7421245752840315], 
                [1.8219281522029733, 0.009999999871124654, 110.744977740406], 
                [123.62694015360536, 0.035738476393541996, 110.26421211295525],
                [179.09104707381357, 0.009999999942754911, 64.56388985043864], 
                [-34.92242236398151, 0.009999999665279535, 64.30257190232442], 
                [84.06749962148288, 0.010000000271818577, -6.549679003169103], 
                [126.52268657070672, 1.8696943524856184, -1.7184184447855757]
            ],
            //barrilagua
            [
                //ok
                [-11.301513824983306, 0.010000000120237162, -17.323137460529324],
                [-252.0343784571228, 1.3619241864852891, 27.889908822072417],
                [-61.13012375920734, 0.01000000018738545, 137.74433215873597],
                [22.511308319204232, 0.010000000001654907, 90.80847342030725],
                [36.54140853750784, 0.009999999992120978, -82.94951475979649],
                [75.82102258137189, 0.01000000023912162, 63.610209163568605],
                [-47.01965743400733, 0.009999999985836228, 51.80831373727112],
                [-22.18057053434032, 0.037699998298646786, -43.85171279952191],
                [83.714923169312, 0.010000000207429638, 71.43931173506851],
                [231.37147410068607, 0.015200000089577781, 111.23222342484647],////
            ],
            //canoquebrado__1_
            [
                //ok
                [223.90343418786958, 0.2199999880550103, -4.553360929061322],
                [180.9849973482703, 0.22000000166977074, 43.92827030605368],
                [186.94236600193292, 0.22000000142769327, 56.93152720305866],
                [-0.6685624200160687, 0.009999999927326586, 64.14087745869705],
                [35.026859992164756, 0.010000000171708656, 41.04824563005628],
                [-31.244434056063564, 0.00999999990658007, 57.35665207822652],
                [-48.692077727327465, 0.010000000190509173, -23.101026856435276],
                [167.53553384457862, 0.21999999769822298, 56.305008786103926],
                [200.24963392495772, 0.009999999643616642, 42.492677481015946],
                [225.96499827324325, 0.0100000000020386, -13.520996507916786],
            ],
            //Balde
            [
                //ok
                [84.42755955681648, 0.01000000009761326, -5.632611987947536],
                [84.27308092890233, 0.010000000038251189, -24.20950524618516],
                [78.54251906258881, 0.00999999974356025, -84.61959246795487],
                [-104.38783624987575, 0.03770000077528102, -30.25958082361785],
                [-20.13905817650919, 0.009999999717360764, 55.83094316196174],
                [229.37792672979404, 0.010000000103326245, -28.982875200514346],
                [115.44511050869237, 0.009999999706516327, 44.023964927103606],
                [-28.86144985937459, 0.010000000002545084, -90.40180348925422],
                [-19.956157856267453, 0.00999999988824185, 6.914472118369062],
                [-12.354856437838773, 0.009999999971280538, 30.7527858430911],
                [69.15965892362539, 0.01000000034411963, 16.70867439564973],
            ],
            //Mangueira
            [
                //ok
                [37.495000676880956, 0.010000000209830606, 59.962359806071085],
                [-31.65999638123288, 0.009999999820096805, 57.80974222534795],
                [84.16000255150293, 0.009999999867800868, 76.98850448296335],
                [104.77500353232224, 0.009999999928705705, -1.3745867645825536],
                [236.11683626063106, 0.015199999839032419, 34.50710061494052],
                [244.1750018905754, 0.009999999905905499, 23.877957206237827],
                [230.4236927708697, 0.009999998246521757, 52.25390936791787],
                [232.14534269985032, 0.1736660664686096, -55.882227504719616],////
                [225.96499324784423, 0.009999999951665117, -13.29430214126142],
                [196.70499693178445, 0.010000000218280736, -30.400204744634543],
            ],
            //PoteDog
            [
                //ok
                [86.0674286686647, 0.009999999957451156, 0.8847681228484283],
                [96.91969334060951, 0.010000000168719048, 39.03131285787236],
                [109.32180832367432, 0.00999999974184207, 107.36262432405039],
                [48.97778751554825, 0.010000000402844877, 37.1373918098827],
                [62.8274730766754, 0.009999999916874946, -30.503534484798966],
                [-7.266439505259483, 0.009999999933698378, -92.5192182171045],
                [-84.31939925635758, 0.010000000007593268, -73.86856095212926],
                [14.824647726344676, 0.010000000108441931, 79.7287909353855],
                [42.33243842177551, 0.010000000211860316, 102.55381918588718],
                [-91.55347576526681, 0.010000000259410058, 14.341183828649116],
            ],
            //Torneira
            [
                //ok
                [90.52382507531259, 0.01000000011978397, -15.080653425457799],
                [-77.74500339133418, 0.010000000394490227, -28.68448510154604],
                [-37.78609085858872, 0.009999999932746473, 45.328894803141964],
                [-20.518758064287205, 0.010000000208065352, 60.51823729915727],
                [-35.48667393874092, 0.009999999627857248, 59.64991398327088],
                [231.2944223646288, 0.21999998991512948, 38.626302858757235],
                [209.38601740729933, 0.21999998821867117, 20.592741046280715],
                [193.51097183654304, 0.21999999318530206, 60.532607614041595],
                [165.5784563672687, 0.21999999816995452, 18.136573321485503],
                [170.8614950974, 0.010000000261150443, 79.26446967173281],
                [183.18932185860578, 0.009999999918748337, 69.75070124863677],
                [197.89417419384677, 0.2199999983586194, 64.6687976873627],
                [203.4194363108836, 0.2200000022324169, -30.835035865028654],
                [224.01738370683154, 1.9501279156003903, -80.57842918503098]
            ],
            //Lixo
            [
                //ok
                [97.17243102819062, 0.010000000189208436, 4.822613570975923],
                [-14.351931503596784, 0.010000000008050458, 36.49885508941148],
                [90.70784206616106, 0.03769999983094485, 47.95962444036518],////
                [50.056484601050926, 0.03769999983269967, 22.43419918815492],////
                [0.7747333899976665, 0.03770000173880805, 35.701750576594435],////
                [9.688330908117681, 0.037699999543090223, -67.21406840587304],////
                [268.45401003104894, 0.06109183099607618, -39.00898257672432],////
                [178.60383885964362, 0.2199999895564828, 56.41509450801217],////
                [244.1785972872626, 0.010000000375265383, -33.14610421763173],
                [253.74109821488986, 0.009999999556480343, 7.8922876076993695],
                [240.50945147875638, 0.009999999638585777, 55.94933546069782],
                [224.84705181403683, 0.01000000004479662, 65.70876871925802],
                [241.6638592021883, 9.360000075757558, 84.55586649747391],
                [198.91945844741318, 9.360000082587815, 108.20319215827908],
                [-105.93595062118841, 0.010000000261959796, 37.91788865726583],
                [-188.36168160010573, 0.5950265039793534, 31.661504926088504]
            ],
            //Pote
            [
                //ok
                [4.870371348339619, 0.010000000157738276, -19.431606041348704],
                [34.417723430714155, 0.00999999964375986, -34.096697159449775],
                [79.42381285785781, 0.010000000109545937, 6.851496084756011],
                [16.46630362451222, 0.010000000247161855, 72.77843438840678],
                [-5.1968120259037915, 0.009999999940333515, 57.698620968177885],
                [-32.30367763697032, 0.010000000062823533, 50.057289043834054],
                [-45.355493807401515, 0.009999999972334583, 2.5341573047601305],
                [-13.353705537800064, 0.009999999566220108, -45.32648227570847],
                [-34.68682295787259, 0.010000000158212785, -11.101453006920293],
                [101.46498983059482, 0.009999999995812248, 17.00909171758942],
                [124.97500984072586, 0.037542627439014487, 13.533215800523626],
                [169.494444556942, 0.00999999958510056, 14.062071836121117],
                [198.7219238317078, 0.009999999860051512, 19.75262512514198],
                [193.82066708692307, 0.009999999874051646, 40.5326423768976],
                [224.66878211944572, 0.2200000018340984, 22.855976537359936],
                [233.35811384535202, 0.009999999665426973, -2.978895600646739],
                [212.25756946263215, 0.22000000254218954, 3.8393097574061983],
                [228.34825605065865, 0.010000000012495569, -30.942842632762233],
            ],
        ],
        itens_frase:
        [
            //'A natureza agradece! Produtos químicos podem contaminar os rios e lençóis freáticos. Continue acumulando pontos e preservando a água.',
            "A natureza agradece!\nÓleo diesel e derivados podem contaminar os rios e os lençóis freáticos.\nContinue acumulando pontos e preservando a água.",
            "Lugar de pneu usado é na borracharia! Pneus expostos ao tempo, podem acumular água e contribuir para a proliferação de mosquitos. Continue acumulando pontos e combatendo a dengue.",
            "Armazenar a água da chuva corretamente é fundamental para poupar e proteger a vida. Continue acumulando pontos e preservando a água",
            "Perfeito! Agora a água chegará aos reservatórios sem desperdício. Continue acumulando pontos e preservando a água.",
            "Em local com água parada, quem faz a festa é o mosquito! Não deixe a água ficar parada em recipientes e continue acumulando pontos.",
            "Limpeza é com vassoura! Não é momento de usar a mangueira! Continue acumulando pontos e preservando a água.",
            "Água limpa e fresquinha é muito melhor. Mantenha os potes de água dos pets sempre limpos e com água fresca. Continue acumulando pontos e combatendo a dengue.",
            "Cada gota de água economizada conta muito! Continue acumulando pontos e preservando a água.",
            "Lugar de lixo é no lixo! O descarte de lixo incorreto pode causar vários problemas para a saúde e para o meio ambiente. Continue acumulando pontos e combatendo a dengue.",
            "Xô mosquito! Limpe e coloque areia nos pratinhos dos vasos, evitando que a água fique parada. Continue acumulando pontos e combatendo a dengue.",
        ],
    },
    mutations: {
        decrement(state, data) {
            state.points -= Number(data);
        },
        increment(state, data) {
            state.points += Number(data);
        },
        update (state, data) {
            state.token = data;
            state.logged = (data !== null) ? true : false;
        },
        update_profile (state, data) {
            state.email  = data ? data.email : null;
            state.id     = data ? data.id : null;
            state.name   = data ? data.name : null;
            state.points = data ? data.points : 0;
        },
        update_started(state, data) {
            state.started = data;
        },
        update_player(state, data) {
            state.player = data;
        },
        update_avatar(state, data) {
            state.avatar = data;
        },
        update_item(state, data) {
            state.item = data;
        },
        update_mobile(state, data) {
            state.mobile = data;
        },
        update_info_started(state, data) {
            state.info_started = data;
        },
        update_itens_count_day(state, data) {
            state.itens_count_day = data;
        },
        update_points(state, data) {
            state.points = data;
        },
    },
    getters: {
        email:        state => state.email,
        name:         state => state.name,
        id:           state => state.id,
        info_started: state => state.info_started,
        points:       state => state.points,
        logged:       state => state.logged,
        mobile:       state => state.mobile,
        token:        state => state.token,
        started:      state => state.started,
        player:       state => state.player,
        avatar:       state => state.avatar,
        item:         state => state.item,
        itens:        state => state.itens,
        itens_name:   state => state.itens_name,
        itens_frase:  state => state.itens_frase,
        itens_ref:    state => state.itens_ref,
        itens_pos:    state => state.itens_pos,
        itens_count_day: state => state.itens_count_day,
        itens_fase_2: state => state.itens_fase_2
    },
    actions: {
        decrement: (state, data) => {
            state.commit('decrement', data);
        },
        increment: (state, data) => {
            state.commit('increment', data);
        },
        update: (state, data) => {
            state.commit('update', data);
        },
        update_profile: (state, data) => {
            state.commit('update_profile', data);
        },
        update_started: (state, data) => {
            state.commit('update_started', data);
        },
        update_player: (state, data) => {
            state.commit('update_player', data);
        },
        update_avatar: (state, data) => {
            state.commit('update_avatar', data);
        },
        update_item: (state, data) => {
            state.commit('update_item', data);
        },
        update_mobile: (state, data) => {
            state.commit('update_mobile', data);
        },
        update_info_started: (state, data) => {
            state.commit('update_info_started', data);
        },
        update_itens_count_day: (state, data) => {
            state.commit('update_itens_count_day', data);
        },
        update_points: (state, data) => {
            state.commit('update_points', data);
        }
    }
})

export { store }
